import React from 'react';
import {Link} from "react-router-dom";
import {LoginForm} from 'components/login/Form';
import {HeaderMobile} from "components/common/HeaderMobile";
import {Alerts} from "components/common/Alerts";
import {images} from 'assets/img/common/common';
import 'assets/sass/login/Login.scss';
import {app} from "app/app";
import SecureSiteWarning from 'components/dashboard/layout/SecureSiteWarning';
import Login2FaModal from './Login2FaModal';
import ModalDeviceAuthorization from './authorization/ModalDeviceAuthorization';


function renderForm(props) {
    const allRoutes = app.routes();
    if (!!props.fatalError) {
        return <div className="login-fatal-error">{props.fatalError}</div>;
    }
    const register = props.confirmationTokenRequiredResponse
        ? null
        : <p>¿Todavía no tenés cuenta en {app.productName()}? <Link to={allRoutes.session.signUp}>Clic aquí</Link></p>;
    return <>
        {register}
        <LoginForm {...props}/>
    </>;
}

export function Login (props) {
    return (
        <>
            <SecureSiteWarning />
            {props.show2FaModal && <Login2FaModal {...props}/>}
            <ModalDeviceAuthorization modalsAuthorization={props.modalsAuthorization} />
            <div className="login">
                <Alerts alerts={props.alerts} className="alert"/>
                <HeaderMobile/>
                <div className="login-image">
                </div>
                <div className="login-content">
                    <img className="logo" src={images.logo} alt={app.productName()}/>
                    <h1>Accedé a tu cuenta</h1>
                    {renderForm(props)}
                </div>
            </div>
        </>
    );
}
